import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  titulo: '',
};

export const ProdutosMercosContext = createContext();

export const ProdutosMercosProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [produtosMercos, setProdutosMercos] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getProdutosMercos = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: produtosMercos?.filter,
        page: produtosMercos?.page,
        size: produtosMercos?.size,
        order: produtosMercos?.order,
        ...payload,
      });
      setProdutosMercos((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosMercosContext.Provider
      value={{ getLoading, getProdutosMercos, produtosMercos }}
    >
      {children}
    </ProdutosMercosContext.Provider>
  );
};
